import Project from "../project";


export default function projectSetCalendarDuration(project:Project, value:number|null) {

    if (_.isNaN(value) || !String(value).trim() || value === null) value = 0;

    if (value === 0) {
        project.startDate   = null
        project.endDate     = null
        return;
    }

    const startDate = project.startDate ? project.startDate : momentDate()
    const endDate   = moment(startDate).add(value-1,'days')

    project.updateStartEnd(startDate, endDate)
}


